export const configAmplify = {
  Auth: {
    region: "eu-west-1",
    userPoolId: "eu-west-1_rjovm25fO",
    userPoolWebClientId: "bcq4io5ut52fk78aojpt03n1q",
    identityPoolId: "eu-west-1:0e538e07-449c-40d4-8cf1-7b5a3b2de618",
    mandatorySignIn: true, // true si tu veux forcer la connexion avant d'accéder à l'application,
    Cognito: {
      loginWith: {}, // Ajoute une config minimale pour éviter les erreurs
    },
  },
  Storage: {
    AWSS3: {
      bucket: "src-k3iko-serverless-bucket",
      region: "eu-west-3",
    },
  },
  OAuth: undefined,
};

export default configAmplify;
